import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import lottie from 'lottie-web';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  isShowLoader = false;
  assetURL = environment.assetURL;
  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.sharedService.isShowLoader.subscribe(data => {
      setTimeout(() => {
        this.isShowLoader = data;
        if (data) {
          this.startLoader()
        }
      }, 100);
    })
  }
  startLoader() {
    if (!document.getElementById('common-loader')) {
      let loader = document.createElement('div');
      loader.setAttribute('id', 'common-loader');
      loader.setAttribute('style', 'height: 50vh; width: 100%');
      (document.querySelector('.loader-modal .loader') as HTMLElement).appendChild(loader);
      this.startLoadAnimation('common-loader');
    }
    (document.querySelector('.loader-modal') as HTMLElement).style.display = 'flex';
  }

  startLoadAnimation(loaderId: string) {
    lottie.loadAnimation({
      container: document.getElementById(loaderId)!,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/lottie/loader-json.json'
    });
    lottie.setSpeed(2);
  }
  ngAfterViewInit() {
  }
}
